import axios from 'axios';

// Usamos la variable de entorno o la URL de Render por defecto
const rawBaseURL = import.meta.env.VITE_API_URL || import.meta.env.VITE_API_BASE_URL || '/api';
const normalizeBaseURL = (url) => {
  if (!url) return '/api';
  if (url.startsWith('/')) return url;
  try {
    const parsed = new URL(url);
    if (!parsed.pathname || parsed.pathname === '/') {
      parsed.pathname = '/api';
    }
    return parsed.toString().replace(/\/$/, '');
  } catch {
    return url;
  }
};

const api = axios.create({
  baseURL: normalizeBaseURL(rawBaseURL),
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

/**
 * FUNCIÓN DE LIMPIEZA DE RUTAS (Intercepta los datos de MongoDB)
 */
const cleanPaths = (data) => {
  if (!data) return data;
  if (typeof data === 'string') {
    // Busca /src/assets/ y lo cambia por /images/ globalmente
    return data.replace(/\/src\/assets\//g, '/images/');
  }
  if (Array.isArray(data)) {
    return data.map(cleanPaths);
  }
  if (data !== null && typeof data === 'object') {
    const newObj = {};
    for (const key in data) {
      newObj[key] = cleanPaths(data[key]);
    }
    return newObj;
  }
  return data;
};

// 1. Interceptor de PETICIÓN (Para el Token)
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      // Usando Template Literals correctamente con comillas invertidas
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// 2. Interceptor de RESPUESTA (Para las Imágenes)
api.interceptors.response.use(
  (response) => {
    if (response.data) {
      response.data = cleanPaths(response.data);
    }
    return response;
  },
  (error) => Promise.reject(error)
);

export default api;